/* eslint-disable quotes */
/* eslint-disable semi */
import { storeMutations } from '@store/mutations.constants';
import licenseState from './state';

export const state = licenseState;
const mutations = {
  [storeMutations.setDemoPaidUsers]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.demoUser = res.data.data;
    }
  },
  [storeMutations.setAgencyOwnUsers]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.agencyUser = res.data;
    }
  },
  [storeMutations.setUsersList]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.usersList = res.data;
    }
  },
};
export default {...mutations };